import { useState } from "react";
import { Box, Typography } from "@material-ui/core";

import { MapTab } from "./tabs/MapTab";
import { AnalysisTab } from "./tabs/AnalysisTab";
import { DataTab } from "./tabs/DataTab";
import { COLORS } from "../../../theme/colors";

export const ReviewData = ({ buildings, setStep, setIsDataConfirmed, resetSteps }) => {
  const [tab, setTab] = useState(0);
  const TabComponent = [MapTab, AnalysisTab, DataTab][tab];

  return (
    <Box mx={12}>
      <Box display="flex" justifyContent="center" gridColumnGap={2}>
        {["Map", "Analysis", "Data"].map((name, i) => (
          <Box
            key={i}
            width={85}
            height={26}
            bgcolor={tab === i ? COLORS.purple : "#E9E9E9"}
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
            top={-13}
            borderRadius={i === 0 ? "5px 0px 0px 5px" : i === 2 ? "0px 5px 5px 0px" : null}
            style={{ cursor: "pointer" }}
            onClick={() => setTab(i)}
          >
            <Typography style={{ fontWeight: "bold", color: tab === i && COLORS.white }}>
              {name}
            </Typography>
          </Box>
        ))}
      </Box>
      <TabComponent
        buildings={buildings}
        setStep={setStep}
        setIsDataConfirmed={setIsDataConfirmed}
        resetSteps={resetSteps}
      />
    </Box>
  );
};
